import ImageView from '../ImageView/ImageView';
import styles from './RoundIconLabelUnit.module.scss';

function RoundIconLabelUnit({
  iconImageUrl,
  labelText,
  subLabelText,
  size = 'default',
}: {
  iconImageUrl: string;
  labelText: string;
  subLabelText?: string;
  size?: 'small' | 'default';
}) {
  return (
    <div className={`${styles.componentStyle} ${styles[`${size}Container`]}`}>
      <div className={`${styles.iconImage} ${styles[`${size}IconImage`]}`}>
        <ImageView src={iconImageUrl} isCircled></ImageView>
      </div>
      <div className={styles.labelContainer}>
        {subLabelText && <p className={styles.subLabel}>{subLabelText}</p>}
        <p className={`${styles.label} ${styles[`${size}Label`]}`}>{labelText}</p>
      </div>
    </div>
  );
}

export default RoundIconLabelUnit;
